export const SPICE_LEVELS = ["Mild", "Medium", "Spicy", "Indian Spicy"];
export const WEIGHTS = ["1/2 lb", "1 lb"];
export const CAKE_SIZES = ["Small", "Medium", "Large", "Custom"];

export const priceWithOptions = (base, opts = {}) => {
  let p = base || 0;
  if (opts.weight === "1/2 lb") p = p / 2;
  if (opts.size === "Medium") p += 10;
  if (opts.size === "Large") p += 20;
  return Math.round(p * 100) / 100;
};

export const optionsLabel = (opts = {}) => [
  opts.base,
  opts.weight,
  opts.size ? (opts.size === "Custom" ? `Custom · ${opts.persons || "?"} people` : { half: "Half Tray", full: "Full Tray" }[opts.size] || opts.size) : null,
  opts.choice && opts.size ? null : opts.choice,
  opts.guests ? `${opts.guests} guests` : null,
  opts.spice,
  opts.spice_summary,
].filter(Boolean).join(" · ");

export const lineKey = (productId, opts = {}, note = "") =>
  [productId, opts.spice || "", opts.base || "", opts.weight || "", opts.size || "", opts.persons || "",
    opts.component_spices ? JSON.stringify(opts.component_spices) : "", note].join("|");
